// import React from 'react';
import React, { useState } from 'react';
import './style/accessDenied.scss';
import { Button } from '@material-ui/core';
import { ArrowBack as ArrowBackIcon } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import accessdenied from '../assets/images/accessdenied.svg';

function AccessDenied() {
  const [copied, setCopied] = useState(false);
  const history = useHistory();

  function copy() {
    const el = document.createElement('input');
    el.value = window.location.href;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    setCopied(true);
  }

  const url = window.location.href;

  const goToPreviousPath = (e) => {
    e.preventDefault();
    history.goBack();
  };

  return (
    <div className="Holder">
      <img src={accessdenied} style={{ width: '280px' }} />
      <div className="sectionHeading" style={{ color: '#1e38ea' }}>
        403 error!
      </div>
      <div className="sectionHeadingLg">Access Denied</div>
      <div
        className="sectionPara_payment"
        style={{ fontSize: '20px', textAlign: 'center', lineHeight: '30px', marginBottom: '2em' }}
      >
        Sorry about that, But you don’t have permission to access this page. <br />
        Request your Admin to access this page.
      </div>
      <div>
        <Button onClick={goToPreviousPath} className="adPrimaryButtonOutlined" style={{ marginRight: '16px' }}>
          <ArrowBackIcon style={{ verticalAlign: 'middle', width: '18px', height: '18px', marginRight: '6px' }} />
          <div style={{ display: 'inline-block', verticalAlign: 'initial', fontSize: '16px' }}>Go Back</div>
        </Button>
        <Button href="/stores" className="adPrimaryButton">
          <div style={{ display: 'inline-block', verticalAlign: 'initial', fontSize: '16px' }}>Go to All store</div>
        </Button>
      </div>
      <div className="copyurl_holder">
        <div>{url}</div>
        <button className="aisleLinkButton" style={{ cursor: 'pointer' }} onClick={copy}>
          {!copied ? 'Copy Url' : 'Copied!'}
        </button>
      </div>
    </div>
  );
}

export default AccessDenied;
